var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-fullscreen",style:({'background-image': 'url(' + require('@/assets/event_owner/juventus/calendar-bg_low.jpg') + ')'})},[_c('ModalCalendar',{attrs:{"events":_vm.events}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }